(function (win) {
  win.PAGE_INFO = win.PAGE_INFO || {}
  win.ctag_error = win.ctag_error || function () {}
  win.ctag = win.ctag || function () {}
  // 页面级异常埋点
  // win.onerror = function (message, url, line, column, error) {
  //   // console.log({
  //   //   event_name: 'page::error',
  //   //   event_category: 'all_page',
  //   //   page_name: win.PAGE_INFO.name,
  //   //   page_id: win.PAGE_INFO.id,
  //   //   error_content: `message:${message}, url:${url}, line:${line}, column: ${column}, error: ${error}`,
  //   //   page_url: win.location.href
  //   // })
  //   win.ctag('page_error', {
  //     event_name: 'page::error',
  //     event_category: 'all_page',
  //     page_name: win.PAGE_INFO.name,
  //     page_id: win.PAGE_INFO.id,
  //     error_content: `message:${message}, url:${url}, line:${line}, column: ${column}, error: ${error}`,
  //     page_url: win.location.href
  //   })
  // }

  var httpQueue = new Map()

  win.$$ajax = function (options) {
    var params = options.data || {}
    params = typeof params === 'string' ? JSON.parse(params) : params
    $ && $.ajax(Object.assign(options, { params: params }))
  }

  var Status = {
    succss: {
      code: 1,
      type: 'fetch_succss'
    },
    fail: { // 后端返回报错
      code: 0,
      type: 'fetch_error'
    },
    miss: {
      code: 0,
      type: 'httpstatus_error'
    }
  }

  var baseInfo = {
    page_name: win.PAGE_INFO.name,
    page_id: win.PAGE_INFO.id,
    userid: win.CUSTOMER_EMAIL
  }

  var CALLBACKS = {
    execute: function (item, status) {
      item = item || {}
      item.xhr = item.xhr || {}
      win.ctag_error(Object.assign(baseInfo, {
        request_name: item.xhr.url,
        request_status: Status[status].code,
        error_type: Status[status].type,
        request_time: Number(new Date()),
        error_notes: item.retInfo,
        request_params: item.xhr.params,
        request_waiting_time: Number(new Date()) - item.timestamp
      }))
    },
    success: function (item) {
      CALLBACKS.execute(item, 'succss')
    },
    fail: function (item) {
      CALLBACKS.execute(item, 'fail')
    },
    miss: function (item) {
      CALLBACKS.execute(item, 'miss')
    }
  }
  $.ajaxSetup({
      beforeSend: function(xhr, jqXHR) {  
        httpQueue.set(xhr, {
          timestamp: Number(new Date()),
          xhr: jqXHR
        })
      },
      complete: function(xhr) {
          try {
            xhr = xhr || {}
            var item = httpQueue.get(xhr) || {}
            var data = xhr.responseJSON || {}
            var keys = Object.keys(data)
            var isBFFRequest = keys.length > 0 
              && keys.every(key => ['data', 'retCode', 'retInfo', 'success', 'timeStamp'].includes(key))
            if (!isBFFRequest) return
            if (xhr.readyState === 4 && xhr.status === 200) {
              Object.assign(item, {retInfo: data.retInfo})
              if (data.success) {
                // CALLBACKS['success'](item)
              } else {
                CALLBACKS['fail'](item)
              }
            } else {
              CALLBACKS['miss'](item)
            }
          } catch (e) {
            console.error(e)
          }
      },
      error: function (xhr, textStatus) {
        var item = httpQueue.get(xhr) || {}
        Object.assign(item, {retInfo: textStatus})
        CALLBACKS['miss'](item)
      }
  })

})(window || {})